// AppReleases.js — iOS REVISION AND HIGHLIGHT (21 Eyl 2026)
//
// 🔑 Serkan: *"Super adminde iOS revision and highlight sekmesi olcak. Oraya
//    girince daha once yayinlanmis butun surumlerin yayinlanma tarihi ile
//    kronolojik olarak gorecez, EN ALTTA EN YENISI. Her birine tiklayinca o
//    build'in rev highlight penceresi hemen saginda acilacak (ayni FAQ and Help
//    modul gibi): neler kaldirildi, neler duzeltildi, neler eklendi."*
// ve: *"Biz burdan Xcode'a yeni surumu gonderirken bir guncelleme commiti de
//    super admine atilsin, orasi da guncellensin."*
//
// 🔑 OLCUM ile BELGE AYRIMI (Serkan onayi): `build` ve `commit_sha` bir
//    OLCUMDUR — TestFlight'a fiilen ne gitti. Yazildiktan sonra DEGISTIRILEMEZ
//    (veritabani tetikleyicisi reddeder). Uc baslik ise BELGEDIR: insan yazar,
//    yazim hatasi olur, GEREKCEYLE duzeltilir. Satir SILINEMEZ (Ilke 4).
//
// 🔑 GUNCEL SURUM SAKLANMAZ, TURETILIR: en yuksek `build`. Bayrak tutsaydik er
//    ya da gec kayitla celisirdi (Ilke 3).
//
// 🔴 NEDEN VAR: bugun depodaki build numarasi ile TestFlight'takinin ayrisabildigi
//    olculdu (21 Eyl: depoda 65, ASC'de 68) ve bunu ancak yukleme reddedince
//    ogrendik. Ayrica EASA uyumluluk raporu operator yukumluluk listesinde
//    *"6 — Konfigurasyon ve surum kontrolu proseduru GM1(b)(3) EKSIK"* diyor;
//    surum + degisiklik + kim + ne zaman kaydi o maddenin kanitidir.
import { useState, useEffect, useCallback, useRef } from 'react';
import { supabase } from '../supabaseClient';
import { withReason } from '../editReason';
// Harf kapisi burada da gecerli (Serkan, 20 Eyl): *"Uygulamanin hicbir yerinde
// Ingilizce disinda karakter girilemesin."*  Surum notlari pilota da gosteriliyor
// ve rapor yoluna girebilir — istisna yapmiyoruz.
import HarfliGiris from './HarfliGiris';
import { zAlan } from './tasarim';   // zorunlu alan rengi — iPad kuralı, kaydetme kapısının koşuluyla (5 Eki 2026)
import { utcGun } from '../utcTarih';
import { GerekceIpucu, gerekceTamam, gerekceIpucuMetni } from './gerekce';   // ortak gerekçe kuralı + satırı (21 Eki 2026, K7)

const C = {
  bg2:'var(--bg2)', bg3:'var(--bg3)', border:'var(--border)',
  t1:'var(--t1)', t2:'var(--t2)', t3:'var(--t3)', accent:'var(--accent)',
  green:'var(--green)', orange:'var(--orange)', red:'var(--red)',
};
const kutu = { width:'100%', boxSizing:'border-box', background:C.bg3, color:C.t1,
               border:`1px solid ${C.border}`, borderRadius:4, padding:'7px 9px',
               fontSize:12, fontFamily:'var(--mono)' };
const etiket = { display:'block', fontSize:9, color:C.t3, fontWeight:700,
                 letterSpacing:1, marginBottom:4 };

/** "v1.69" — uygulamadaki `AppInfo.shortVersion` ile AYNI dil (16 Agu karari). */
export const surumEtiketi = (build) => `v1.${build}`;

// Gosterim UTC (Serkan: "her zaman UTC takip edecegiz") — tek kaynak ../utcTarih.js.
const tarih = utcGun;

/** Cok satirli metni diziye cevirir: her satir bir madde, bos satirlar atilir. */
const satirlar = (s) => String(s || '').split('\n').map(x => x.trim()).filter(Boolean);

export default function AppReleases({ toast, myProfile }) {
  const [rows, setRows] = useState([]);
  const [secili, setSecili] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [ekle, setEkle] = useState(false);
  const listeRef = useRef(null);

  const load = useCallback(async () => {
    setYukleniyor(true);
    // ARTAN sira: en yenisi EN ALTTA (Serkan'in istedigi kronolojik okuma).
    const { data, error } = await supabase.from('app_releases')
      .select('*').eq('platform', 'ios').order('build', { ascending: true });
    if (error) { toast(error.message, 'error'); setYukleniyor(false); return; }
    setRows(data || []);
    setSecili(s => (data || []).find(r => r.id === s?.id) || (data || [])[(data || []).length - 1] || null);
    setYukleniyor(false);
  }, [toast]);

  useEffect(() => { load(); }, [load]);

  // Liste acilinca EN ALTA kayar: en yenisi ekranda, her seferinde asagi inmeye
  // gerek kalmaz. Sira degismiyor, yalnizca nereye bakildigi.
  useEffect(() => {
    if (!yukleniyor && listeRef.current) listeRef.current.scrollTop = listeRef.current.scrollHeight;
  }, [yukleniyor, rows.length]);

  const guncel = rows.length ? rows[rows.length - 1] : null;

  return (
    <div style={{ flex:1, display:'flex', overflow:'hidden', minWidth:0 }}>
      {/* ── SOL: kronolojik liste, EN ALTTA EN YENI ── */}
      <div style={{ width:230, borderRight:`1px solid ${C.border}`, display:'flex',
                    flexDirection:'column', flexShrink:0, background:C.bg2 }}>
        <div style={{ padding:'10px 12px', borderBottom:`1px solid ${C.border}` }}>
          <div style={{ ...etiket, marginBottom:2 }}>PUBLISHED BUILDS</div>
          <div style={{ fontSize:9, color:C.t3 }}>oldest first · newest at the bottom</div>
        </div>
        <div ref={listeRef} style={{ flex:1, overflowY:'auto', padding:'6px 8px' }} data-testid="release-list">
          {yukleniyor && <div style={{ padding:12, fontSize:10, color:C.t3 }}>LOADING...</div>}
          {!yukleniyor && !rows.length && (
            <div style={{ padding:12, fontSize:10, color:C.t3, lineHeight:1.7 }}>
              No releases recorded yet. The record starts from the first build you
              add here — earlier builds are deliberately not back-filled, because a
              record written after the fact must not look like one kept at the time.
            </div>
          )}
          {rows.map(r => {
            const sec = secili?.id === r.id;
            return (
              <div key={r.id} onClick={() => setSecili(r)} data-testid={`release-${r.build}`}
                   style={{ padding:'8px 10px', marginBottom:3, borderRadius:5, cursor:'pointer',
                            background: sec ? 'var(--accent-soft)' : 'transparent',
                            borderLeft:`3px solid ${sec ? C.accent : 'transparent'}` }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <span style={{ fontSize:12, fontWeight:700, color: sec ? C.accent : C.t1,
                                 fontFamily:'var(--mono)' }}>{surumEtiketi(r.build)}</span>
                  {guncel?.id === r.id && (
                    <span style={{ fontSize:8, fontWeight:700, letterSpacing:1, color:C.green,
                                   border:`1px solid ${C.green}`, borderRadius:3, padding:'1px 5px' }}>
                      CURRENT
                    </span>
                  )}
                </div>
                <div style={{ fontSize:9.5, color:C.t3, marginTop:2, fontFamily:'var(--mono)' }}>{tarih(r.released_at)}</div>
              </div>
            );
          })}
        </div>
        <div style={{ padding:10, borderTop:`1px solid ${C.border}` }}>
          <button onClick={() => { setEkle(true); setSecili(null); }} data-testid="release-add"
                  style={{ width:'100%', padding:'8px', fontSize:10, fontWeight:700, letterSpacing:1,
                           cursor:'pointer', color:'#08131f', background:C.accent,
                           border:'none', borderRadius:4, fontFamily:'var(--mono)' }}>
            + ADD RELEASE
          </button>
        </div>
      </div>

      {/* ── SAG: secili build'in rev highlight penceresi ── */}
      <div style={{ flex:1, overflowY:'auto', padding:18, minWidth:0 }}>
        {ekle
          ? <ReleaseForm myProfile={myProfile} toast={toast}
              sonBuild={guncel?.build || 0}
              onClose={() => { setEkle(false); load(); }} />
          : secili
          ? <ReleaseDetay r={secili} guncelMi={guncel?.id === secili.id}
              toast={toast} onSaved={load} />
          : <div style={{ fontSize:11, color:C.t3 }}>Select a build on the left.</div>}
      </div>
    </div>
  );
}

// ── DETAY: uc baslik + duzeltme ──────────────────────────────────────
function ReleaseDetay({ r, guncelMi, toast, onSaved }) {
  const [duzenle, setDuzenle] = useState(false);
  const [form, setForm] = useState(null);
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => { setDuzenle(false); setReason(''); }, [r.id]);

  const ac = () => {
    setForm({ removed:(r.removed||[]).join('\n'), fixed:(r.fixed||[]).join('\n'), added:(r.added||[]).join('\n') });
    setDuzenle(true);
  };

  const kaydet = async () => {
    if (!gerekceTamam(reason)) { toast(gerekceIpucuMetni(reason), 'error'); return; }
    setSaving(true);
    try {
      // GEREKCE BASLIKLA GIDER: veritabani tetikleyicisi onu okur, yoksa yazmayi
      // reddeder ve iz de yazmaz (editReason.js boru hatti).
      const sb = await withReason(reason.trim());
      const { error } = await sb.from('app_releases').update({
        removed: satirlar(form.removed), fixed: satirlar(form.fixed), added: satirlar(form.added),
      }).eq('id', r.id);
      if (error) { toast(error.message, 'error'); setSaving(false); return; }
      toast(`${surumEtiketi(r.build)} highlights updated.`, 'success');
      setDuzenle(false); setReason(''); onSaved();
    } catch (e) { toast(String(e.message || e), 'error'); }
    setSaving(false);
  };

  const blok = (baslik, renk, liste) => (
    <div style={{ marginBottom:16 }}>
      <div style={{ fontSize:10, fontWeight:700, letterSpacing:1.4, color:renk, marginBottom:6 }}>{baslik}</div>
      {liste?.length
        ? <ul style={{ margin:0, paddingLeft:18 }}>
            {liste.map((x, i) => (
              <li key={i} style={{ fontSize:11.5, color:C.t1, lineHeight:1.8 }}>{x}</li>
            ))}
          </ul>
        : <div style={{ fontSize:11, color:C.t3, paddingLeft:2 }}>—</div>}
    </div>
  );

  return (
    <div data-testid="release-detail">
      <div style={{ display:'flex', alignItems:'baseline', gap:10, marginBottom:3 }}>
        <span style={{ fontSize:18, fontWeight:700, color:C.accent, fontFamily:'var(--mono)' }}>
          {surumEtiketi(r.build)}
        </span>
        <span style={{ fontSize:11, color:C.t3, fontFamily:'var(--mono)' }}>{tarih(r.released_at)}</span>
        {guncelMi && (
          <span style={{ fontSize:8.5, fontWeight:700, letterSpacing:1, color:C.green,
                         border:`1px solid ${C.green}`, borderRadius:3, padding:'2px 6px' }}>CURRENT</span>
        )}
      </div>
      {/* commit KANITTIR: "ne degisti" sorusu depodan birebir cikarilabilsin diye.
          Uc baslik bir BEYANDIR; ikisi birlikte anlamli. */}
      <div style={{ fontSize:10, color:C.t3, fontFamily:'var(--mono)', marginBottom:18 }}>
        commit <b style={{ color:C.t2 }}>{r.commit_sha || '—'}</b>
      </div>

      {!duzenle ? (
        <>
          {blok('REMOVED', C.red, r.removed)}
          {blok('FIXED', C.orange, r.fixed)}
          {blok('ADDED', C.green, r.added)}
          <button onClick={ac} data-testid="release-edit"
                  style={{ padding:'7px 14px', fontSize:10, fontWeight:700, letterSpacing:1,
                           cursor:'pointer', color:C.t1, background:'transparent',
                           border:`1px solid ${C.border}`, borderRadius:4, fontFamily:'var(--mono)' }}>
            EDIT HIGHLIGHTS
          </button>
          <div style={{ fontSize:9.5, color:C.t3, marginTop:10, lineHeight:1.7, maxWidth:520 }}>
            The build number and commit cannot be changed — they record what actually
            went to TestFlight. Highlights are written by a person and can be corrected
            with a reason. A published release cannot be deleted.
          </div>
        </>
      ) : (
        <div style={{ maxWidth:560 }}>
          {[['removed','REMOVED'],['fixed','FIXED'],['added','ADDED']].map(([k, t]) => (
            <div key={k} style={{ marginBottom:12 }}>
              <label style={etiket}>{t} — one per line</label>
              <HarfliGiris as="textarea" rows={4} style={{ ...kutu, resize:'vertical' }}
                        value={form[k]} data-testid={`release-${k}`}
                        onChange={v => setForm(p => ({ ...p, [k]: v }))} />
            </div>
          ))}
          <div style={{ marginBottom:12 }}>
            <label style={etiket}>REASON *</label>
            <HarfliGiris {...zAlan(kutu, true, gerekceTamam(reason))} value={reason} data-testid="release-reason"
                   placeholder="e.g. typo in the FIXED list" onChange={setReason} />
            <GerekceIpucu metin={reason} testid="release-reason-ipucu" />
          </div>
          <div style={{ display:'flex', gap:9 }}>
            <button onClick={() => setDuzenle(false)}
                    style={{ padding:'7px 14px', fontSize:10, fontWeight:700, letterSpacing:1,
                             cursor:'pointer', color:C.t1, background:'transparent',
                             border:`1px solid ${C.border}`, borderRadius:4 }}>CANCEL</button>
            <button onClick={kaydet} disabled={saving} data-testid="release-save"
                    style={{ padding:'7px 16px', fontSize:10, fontWeight:700, letterSpacing:1,
                             cursor:'pointer', color:'#08131f', background:C.accent,
                             border:'none', borderRadius:4 }}>{saving ? 'SAVING...' : 'SAVE'}</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── YENI SURUM KAYDI ─────────────────────────────────────────────────
function ReleaseForm({ sonBuild, myProfile, toast, onClose }) {
  const [f, setF] = useState({ build:'', commit_sha:'', removed:'', fixed:'', added:'' });
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);

  const kaydet = async () => {
    const b = parseInt(f.build, 10);
    if (!Number.isFinite(b) || b <= 0) { toast('Build number is required.', 'error'); return; }
    // Geriye gitmek KAYIT HATASIDIR: TestFlight de daha kucuk bir numarayi kabul
    // etmez. Burada durdurmak, yanlis satirin hic yazilmamasini saglar.
    if (b <= sonBuild) { toast(`Build must be higher than the last recorded one (${sonBuild}).`, 'error'); return; }
    if (!gerekceTamam(reason)) { toast(gerekceIpucuMetni(reason), 'error'); return; }
    setSaving(true);
    try {
      const sb = await withReason(reason.trim());
      const { error } = await sb.from('app_releases').insert({
        platform:'ios', build:b, commit_sha: f.commit_sha.trim() || null,
        released_by: myProfile?.id ?? null,
        removed: satirlar(f.removed), fixed: satirlar(f.fixed), added: satirlar(f.added),
      });
      if (error) { toast(error.message, 'error'); setSaving(false); return; }
      toast(`${surumEtiketi(b)} recorded.`, 'success');
      onClose();
    } catch (e) { toast(String(e.message || e), 'error'); }
    setSaving(false);
  };

  return (
    <div style={{ maxWidth:560 }} data-testid="release-form">
      <div style={{ fontSize:13, fontWeight:700, color:C.accent, letterSpacing:1, marginBottom:4 }}>
        ADD RELEASE
      </div>
      <div style={{ fontSize:10, color:C.t3, lineHeight:1.7, marginBottom:16 }}>
        Record what actually went out. The build number and commit cannot be changed
        afterwards; the three lists can be corrected with a reason. Crews read the same
        three lists — at sign-in when an update is waiting, and in WHAT'S NEW afterwards.
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 2fr', gap:12, marginBottom:12 }}>
        <div>
          <label style={etiket}>BUILD * {sonBuild ? `(last: ${sonBuild})` : ''}</label>
          <input {...zAlan(kutu, true, Number.isFinite(parseInt(f.build, 10)) && parseInt(f.build, 10) > Math.max(0, sonBuild || 0))}
                 value={f.build} data-testid="form-build" placeholder="70"
                 onChange={e => setF(p => ({ ...p, build: e.target.value.replace(/[^0-9]/g, '') }))} />
        </div>
        <div>
          <label style={etiket}>COMMIT</label>
          <HarfliGiris style={kutu} value={f.commit_sha} data-testid="form-commit" placeholder="d1f00e9"
                 onChange={v => setF(p => ({ ...p, commit_sha: v.replace(/[^0-9a-fA-F]/g, '') }))} />
        </div>
      </div>
      {[['removed','REMOVED'],['fixed','FIXED'],['added','ADDED']].map(([k, t]) => (
        <div key={k} style={{ marginBottom:12 }}>
          <label style={etiket}>{t} — one per line</label>
          <HarfliGiris as="textarea" rows={3} style={{ ...kutu, resize:'vertical' }}
                    value={f[k]} data-testid={`form-${k}`}
                    onChange={v => setF(p => ({ ...p, [k]: v }))} />
        </div>
      ))}
      <div style={{ marginBottom:14 }}>
        <label style={etiket}>REASON *</label>
        <HarfliGiris {...zAlan(kutu, true, gerekceTamam(reason))} value={reason} data-testid="form-reason"
               placeholder="e.g. build 70 uploaded to TestFlight" onChange={setReason} />
        <GerekceIpucu metin={reason} testid="form-reason-ipucu" />
      </div>
      <div style={{ display:'flex', gap:9 }}>
        <button onClick={onClose}
                style={{ padding:'7px 14px', fontSize:10, fontWeight:700, letterSpacing:1,
                         cursor:'pointer', color:C.t1, background:'transparent',
                         border:`1px solid ${C.border}`, borderRadius:4 }}>CANCEL</button>
        <button onClick={kaydet} disabled={saving} data-testid="form-save"
                style={{ padding:'7px 16px', fontSize:10, fontWeight:700, letterSpacing:1,
                         cursor:'pointer', color:'#08131f', background:C.accent,
                         border:'none', borderRadius:4 }}>{saving ? 'SAVING...' : 'RECORD RELEASE'}</button>
      </div>
    </div>
  );
}
